module.exports = {"TXTCLI_How_it_worksX":{"id":"TXTCLI_How_it_worksX","defaultMessage":"Lássuk, hogyan működik!","track":"How it works."}}